import { render, staticRenderFns } from "./TranferNfts.vue?vue&type=template&id=63378849&"
import script from "./TranferNfts.vue?vue&type=script&lang=js&"
export * from "./TranferNfts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports